import { render, staticRenderFns } from "./challenge.vue?vue&type=template&id=c3837300&scoped=true"
import script from "./challenge.vue?vue&type=script&lang=js"
export * from "./challenge.vue?vue&type=script&lang=js"
import style0 from "./challenge.vue?vue&type=style&index=0&id=c3837300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3837300",
  null
  
)

export default component.exports